import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

// Async thunk for editing agents
export const editAgents = createAsyncThunk(
  'agents/editAgents',
  async ({ id, updatedAgentData }, { rejectWithValue }) => {
    try {
      const response = await axios.patch(
        `${apiUrl}/GetAgents/${id}/`,
        updatedAgentData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Something went wrong';
      return rejectWithValue(errorMessage);
    }
  }
);

// Initial state
const initialState = {
  agents: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Slice
const agentsSlice = createSlice({
  name: 'agents',
  initialState,
  reducers: {
    resetStatus(state) {
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Handle editAgents
    builder
      .addCase(editAgents.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(editAgents.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Update the specific agent in the list
        const index = state.agents.findIndex((agent) => agent.id === action.payload.id);
        if (index !== -1) {
          state.agents[index] = action.payload;
        }
      })
      .addCase(editAgents.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { resetStatus } = agentsSlice.actions;
export default agentsSlice.reducer;
